import { useState } from "react";
import { AppRoleDef, RoleDef } from "../../api/users/actions";
import { Dictionary, useUser } from "../../api/users/store";
import DropdownControl from "../../components/DropdownControl";
import { Button, Col, Form, Row } from "react-bootstrap";
import { OWNER_ROLE } from "../../constants";
import useUXStore from "../../api/ux/store";
import { AppRole } from "../../api/reg/actions";

type RoleSelectorProps = {
    defs : Dictionary<AppRoleDef>
    email? : string
    onConfirm? : (roles:AppRole[]) => void
    showConfirm? : boolean
    emptyData? : boolean // true if this data is started from scratch
    onChanged? : (roles:AppRole[]) => void
}

type RoleCheckboxProps = {
    disableEdit: boolean
    role: RoleDef
    onChanged: (checked:boolean,role:RoleDef) => void
    checked: boolean
}


const RoleCheckbox: React.FC<RoleCheckboxProps> = ({checked,disableEdit,role, onChanged}) => {
    const [val,setVal] = useState(checked)
    const _onChanged = (e:any) => {
        onChanged(e.target.checked, role)
        setVal(e.target.checked)
    }
    if (role.id === OWNER_ROLE) return <></>
    return <Col> 
        <Form.Check
            style={{paddingLeft:70}}
            disabled={disableEdit}
            type="switch" 
            label={
                <span>
                    {role.name}
                    {role.desc && (
                        <span style={{color: '#6c757d', marginLeft: '8px', fontSize: '0.9em'}}>
                            {role.desc}
                        </span>
                    )}
                </span>
            }
            checked={val}
            onChange={_onChanged}/>
    </Col>
}


const RoleSelector : React.FC<RoleSelectorProps> = ({
    defs, email="", onConfirm=null, emptyData=false, showConfirm=true, onChanged=null
}) => {
    const [ app, setApp ] = useState(0);
    const { hasUserRole } = useUser(state => state)
    const [ dirty, setDirty] = useState(false)
    const [ data, setData ] = useState<Dictionary<AppRole>>({})
    const { hideDialog } = useUXStore(state => state)

    const isRoleChecked = (app:string, role:string) => {
        if (!emptyData && hasUserRole(email, app, [role] )) return true
        if (!data[app]) return false
        return data[app]?.roles?.includes(role) ?? false
    }
    const getCurentApp = () => Object.values(defs)[app]

    const onSelectApp = (key:any,index:number) => {
        setApp(index)
    }
    const onChangeRole = (checked:boolean,role:RoleDef) => {
        setDirty(true)
        const capp = getCurentApp()
        const cdata = {...data}
        let roles : string[] = []
        if (!cdata[capp!.id]) {
            if (!emptyData) {
                roles = capp?.roles?.map(role => role.id)!
                roles = roles.filter(id => hasUserRole(email,capp!.id,[id])) ?? []
            }
        } else 
            roles = cdata[capp!.id]!.roles

        if (checked)
        {
            roles.push(role.id)
            cdata[capp!.id] = {app:capp!.id, roles: roles}
        }
        else 
            cdata[capp!.id] = {app:capp!.id, roles:roles.filter(item => item !== role.id)}

        setData(cdata)
        
        if (onChanged) onChanged(Object.values(cdata).filter(item => item !== null) as AppRole[])
    }
    const _onConfirm = () => {
        setDirty(false)
        const roles = Object.values(data!).filter(item => item !== null) as AppRole[]
        if (onConfirm) onConfirm(roles)
        hideDialog("roleBtn")
    }
    return <>
        <Row>
            <Col>
            <DropdownControl selected={app} items={Object.keys(defs).map(k => defs[k]?.name!)} 
                onSelected={onSelectApp}
                text="App"
            />
            </Col>
        </Row>
        <br/>
        <Row>
        <Col>
            {getCurentApp()?.roles?.map(role => <Row>
                <RoleCheckbox 
                    key={"role-"+role.id}
                    role={role} 
                    disableEdit={false}
                    onChanged={onChangeRole}
                    checked={isRoleChecked(Object.values(defs)[app]!.id,role.id)}/>
            </Row>)}
        </Col>
        </Row>
        { showConfirm && <Row>
            <Col >
                <Button disabled={!dirty} style={{marginTop:10,float:'right'}} onClick={_onConfirm}>Apply</Button>
            </Col>
        </Row>}
    </>
}

export default RoleSelector;
